import { Link } from "react-router-dom";
import { DONATE_URL, X_URL } from "@/lib/links";
import { XIcon } from "@/components/XIcon";
import { NewsletterSignup } from "@/components/NewsletterSignup";

export const Footer = () => {
  return (
    <footer data-testid="main-footer" className="bg-[#0A1128] text-white grain">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16 grid gap-10 md:grid-cols-3 relative z-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <img src="/logo-emblem.png" alt="Patriot Power USA" className="h-14 w-auto" />
            <span className="font-display text-2xl">
              PATRIOT POWER <span className="text-[#D90429]">USA</span>
            </span>
          </div>
          <p className="text-white/60 max-w-xs leading-relaxed">
            United in strength. Prepared to protect. A national movement of citizens
            committed to the defense of community and country.
          </p>
          <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mt-8 mb-1">Join Our Newsletter</h4>
          <p className="text-white/50 text-sm">Get mission updates and event alerts.</p>
          <NewsletterSignup variant="footer" />
          <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mt-8 mb-3">Follow Us</h4>
          <a
            href={X_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-x-link"
            aria-label="Follow Patriot Power USA on X"
            className="inline-flex items-center justify-center w-11 h-11 border border-white/15 text-white/80 hover:text-white hover:border-[#D90429] transition-colors duration-200"
          >
            <XIcon className="w-5 h-5" />
          </a>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">Get Involved</h4>
          <ul className="space-y-3">
            <li><Link to="/join" className="text-white/80 hover:text-[#D90429] transition-colors duration-200">Join Our Newsletter</Link></li>
            <li><Link to="/start-a-chapter" className="text-white/80 hover:text-[#D90429] transition-colors duration-200">Start a Chapter</Link></li>
            <li><a href={DONATE_URL} target="_blank" rel="noopener noreferrer" className="text-white/80 hover:text-[#D90429] transition-colors duration-200">Donate</a></li>
            <li><Link to="/events" className="text-white/80 hover:text-[#D90429] transition-colors duration-200">Events</Link></li>
            <li><Link to="/divisions" className="text-white/80 hover:text-[#D90429] transition-colors duration-200">Our Divisions</Link></li>
            <li><Link to="/schools" className="text-white/80 hover:text-[#D90429] transition-colors duration-200">United Patriot Schools</Link></li>
            <li><Link to="/store" className="text-white/80 hover:text-[#D90429] transition-colors duration-200">Store</Link></li>
            <li><Link to="/about" className="text-white/80 hover:text-[#D90429] transition-colors duration-200">About Us</Link></li>
            <li><Link to="/founder" className="text-white/80 hover:text-[#D90429] transition-colors duration-200">Our Founder</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="text-xs uppercase tracking-[0.2em] text-white/40 mb-4">Organization</h4>
          <ul className="space-y-3 text-white/80">
            <li>Nationwide Chapters</li>
            <li>contact@patriotpowerusa.org</li>
            <li><Link to="/admin/login" className="hover:text-[#D90429] transition-colors duration-200">Admin Portal</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-white/40 text-sm relative z-10">
        © {new Date().getFullYear()} Patriot Power USA. All rights reserved.
      </div>
    </footer>
  );
};
